import styled from "styled-components";

export const StyledLabel = styled.div`
  display: flex;
  margin-bottom: 15px;
`;

export const MainLabel = styled.label`
  font-family: Public Sans;
  font-weight: 800;
  font-size: 16px;
  line-height: 19px;
  color: #2f2f2f;
`;

export const Spacer = styled.div`
  flex-grow: 1;
`;

export const IsRequiredLabel = styled.div`
  font-family: Public Sans;
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 19px;
  color: #2f2f2f;
  opacity: 0.8;
`;
